module.exports = __webpack_public_path__ + "static/media/driver.959cecd7.svg";